import Flex from "../../components/Flex"
import Screen from "./components/Screen"
import { spacing } from "./styles"

import "./AaoLens.scss"
import Button from "./components/Button"
import datasource from "../../datasource"
import MobileIcon from "../../components/MobileIcon"

interface Step {
    title: string
    text: string
}

interface Capability {
    title: string
    description: string
}

const {
    pageTitle,
    pageSubTitle,
    heroCtaLabel,
    heroCtaLink,
    pitch,
    highlight,
    flow,
    capabilities,
    welcomeTitle,
    welcomeSubTitle,
    welcomeBtnLabel
} = datasource.aaoLens

export default () => {

    // the app lives on its own domain, so this leaves the site rather than routing
    const goToApp = () => {
        window.open(heroCtaLink, "_blank", "noopener,noreferrer")
    }

    return (
        <div className="mb-aaolens">
            <Screen className="mb-aaolens__title-screen">
                <Flex vertical gap={spacing("xl")}>
                    <MobileIcon.AaoLens width={46} height={46}></MobileIcon.AaoLens>
                    <div className="mb-aaolens__title">{pageTitle}</div>
                    <div className="mb-aaolens__subTitle">{pageSubTitle}</div>
                    <Button onClick={goToApp}>
                        <Flex gap={spacing("md")} reposive={false} align="center" justify="center">
                            {heroCtaLabel}
                            <MobileIcon.ArrowUp width={20} height={20}></MobileIcon.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </Screen>

            <Screen className="mb-aaolens__pitch-screen">
                <Flex vertical gap={spacing("lg")} className="mb-aaolens__panel">
                    <div className="mb-aaolens__section-title">{pitch.title}</div>
                    {pitch.paragraphs.map((paragraph, i) => (
                        <div key={i} className="mb-aaolens__pitch__text">{paragraph}</div>
                    ))}
                </Flex>
            </Screen>

            <Screen className="mb-aaolens__highlight-screen">
                <Flex vertical gap={spacing("lg")} className="mb-aaolens__highlight">
                    <div className="mb-aaolens__highlight__eyebrow">{highlight.eyebrow}</div>
                    <div className="mb-aaolens__highlight__title">{highlight.title}</div>
                    <div className="mb-aaolens__highlight__description">{highlight.description}</div>
                    <Flex vertical gap={spacing("md")} className="mb-aaolens__highlight__examples">
                        {highlight.examples.map(example => (
                            <div key={example} className="mb-aaolens__highlight__example">&ldquo;{example}&rdquo;</div>
                        ))}
                    </Flex>
                    <Flex vertical gap={spacing("md")}>
                        {highlight.points.map(point => (
                            <div key={point} className="mb-aaolens__highlight__point">{point}</div>
                        ))}
                    </Flex>
                </Flex>
            </Screen>

            <div className="mb-aaolens__flow-box">
                <Flex vertical gap={spacing("3xl")}>
                    <Flex vertical gap={spacing("md")}>
                        <div className="mb-aaolens__section-title">{flow.title}</div>
                        <div className="mb-aaolens__section-subTitle">{flow.subTitle}</div>
                    </Flex>
                    {/* plain div, not Flex: the connecting rail is drawn on this container */}
                    <div className="mb-aaolens__flow__steps">
                        {(flow.steps as Step[]).map((step, idx) => <StepRow key={step.title} step={step} index={idx}></StepRow>)}
                    </div>
                </Flex>
            </div>

            <Screen className="mb-aaolens__capabilities-screen">
                <Flex vertical gap={spacing("md")} className="mb-aaolens__section-head">
                    <div className="mb-aaolens__section-title">{capabilities.title}</div>
                    <div className="mb-aaolens__section-subTitle">{capabilities.subTitle}</div>
                </Flex>
                <Flex vertical gap={spacing("lg")} className="mb-aaolens__capabilities">
                    {(capabilities.items as Capability[]).map(capability => (
                        <Flex vertical gap={spacing("md")} key={capability.title} className="mb-capability-card">
                            <div className="mb-capability-card__title">{capability.title}</div>
                            <div className="mb-capability-card__description">{capability.description}</div>
                        </Flex>
                    ))}
                </Flex>
            </Screen>

            <div className="mb-aaolens__welcome-box">
                <Flex vertical gap={spacing("lg")} className="mb-aaolens__welcome">
                    <div className="mb-aaolens__welcome__title">{welcomeTitle}</div>
                    <div className="mb-aaolens__welcome__subTitle">{welcomeSubTitle}</div>
                    <Button onClick={goToApp}>
                        <Flex gap={spacing("md")} reposive={false} align="center" justify="center">
                            {welcomeBtnLabel}
                            <MobileIcon.ArrowUp width={20} height={20}></MobileIcon.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </div>
        </div>
    )
}

const StepRow = (props: { step: Step, index: number }) => {
    return (
        <div className="mb-step-row">
            <div className="mb-step-row__rail">
                <div className="mb-step-card__badge">{props.index + 1}</div>
            </div>
            <div className="mb-step-card">
                <div className="mb-step-card__title">{props.step.title}</div>
                <div className="mb-step-card__text">{props.step.text}</div>
            </div>
        </div>
    )
}
